import { useMemo } from "react";
import { isStorePanelLocation } from "@utils/storePanelLocation";

export const useStorePanel = () => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  const isStorePanel = useMemo(
    () => isStorePanelLocation(hostname, pathname),
    [hostname, pathname],
  );

  return { isStorePanel };
};
